/**
 * Logo - Main logo component with variants
 * Horizontal (default), Stacked, or Icon-only
 */

import React from 'react';
import './Logo.css';
import { LogoIcon } from './LogoIcon';
import { LogoIconCompact } from './LogoIconCompact';
import { Wordmark } from './Wordmark';

export interface LogoProps {
  variant?: 'horizontal' | 'stacked' | 'icon';
  size?: 'small' | 'medium' | 'large' | 'hero';
  showTagline?: boolean;
  className?: string;
  compact?: boolean; // Use compact version for header/favicon
}

export const Logo: React.FC<LogoProps> = ({ 
  variant = 'horizontal', 
  size = 'medium',
  showTagline = false,
  compact = false,
  className = '' 
}) => {
  // Use compact version for small/medium sizes (header, favicon)
  // Use regular LogoIcon for large and hero sizes
  const useCompact = (size === 'small' || size === 'medium' || compact);
  const IconComponent = useCompact ? LogoIconCompact : LogoIcon;
  
  if (variant === 'icon') {
    return <IconComponent size={size} className={className} />;
  }

  if (variant === 'stacked') {
    return (
      <div className={`logo-stacked logo-stacked-${size} ${className}`}>
        <IconComponent size={size} />
        <Wordmark size={size} />
        {showTagline && size === 'hero' && (
          <div className="logo-tagline">competitive code typing</div>
        )}
      </div>
    );
  }

  // Horizontal (default)
  return (
    <div className={`logo-horizontal logo-horizontal-${size} ${className}`}>
      <IconComponent size={size} />
      <Wordmark size={size} />
      {showTagline && (
        <div className="logo-tagline">competitive code typing</div>
      )}
    </div>
  );
};

